
import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlContainer, FormGroupDirective, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-sgke330d-condition',
  templateUrl: './sgke330d-condition.component.html',
  styleUrl: './sgke330d-condition.component.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class Sgke330dConditionComponent implements OnInit, OnDestroy {

  /** 当日日付 */
  @Input() todayDate: Date;

  /** 親FormGroup */
  parentForm: UntypedFormGroup;
  /** 検索条件FormGroup */
  searchConditionForm: UntypedFormGroup;

  /**
   * コンストラクタ
   * @param {FormGroupDirective} parent
   * @param {UntypedFormBuilder} fb
   * @param {ChangeDetectorRef} cd
   * @memberof Sgke330dConditionComponent
   */
  constructor(
    private parent: FormGroupDirective,
    private fb: UntypedFormBuilder,
    private cd: ChangeDetectorRef,
  ) {
  }

  /**
   * 初期処理
   * @memberof Sgke330dConditionComponent
   */
  ngOnInit(): void {
    this.searchConditionForm = this.fb.group({
      workymdStart: this.fb.nonNullable.control({ value: null, disabled: false }),
      workymdEnd: this.fb.nonNullable.control({ value: this.todayDate, disabled: false }),
      resultRegzumiFlg: this.fb.nonNullable.control({ value: false, disabled: false}),
    });

    // FormGroupの登録
    this.parentForm = this.parent.form;
    // 親コンポーネントのformに検索条件formを追加
    this.parentForm.addControl("cndt", this.searchConditionForm);
    this.cd.detectChanges();
  }

  /**
   * 終了処理
   * @memberof Sgke330dConditionComponent
   */
  ngOnDestroy(): void {
    this.parentForm.clearValidators();
    this.parentForm.updateValueAndValidity();
    this.parentForm.removeControl('cndt');
  }

  /**
   * フォームをリセットする
   * @memberof Sgke330dConditionComponent
   */
  resetForm(): void{
    this.searchConditionForm.reset();
  }
}
